import React, {useState} from 'react';
import NumberFormat from "react-number-format";

const NumeralValue = ({
                          inputProps,
                          required,
                          size,
                          variant,
                          value,
                          decimalSeparator,
                          allowNegative,
                          onValueChange,
                          onFocus,
                          onBlur
                      }) => {
    const [oldState] = useState(value ? value : "");
    const [newState, setNewState] = useState(undefined);

    return (
        <NumberFormat
            inputProps={inputProps}
            required={required}
            size={size}
            variant={variant}
            value={newState !== undefined ? newState : oldState}
            decimalSeparator={decimalSeparator}
            allowNegative={allowNegative}
            onValueChange={onValueChange}
            onFocus={onFocus}
            onBlur={(e) => {
                const cbFailure = () => setNewState(undefined);
                onBlur(e, cbFailure);
                setNewState(e.target.value);
            }}/>
    )
}

export default NumeralValue;